// export  DsfMessageNotice from './messageNotice';

export const DsfMessageNotice = dsf.defineAsyncComponent("DsfMessageNotice", () => import(/*webpackChunkName:"platform_pc_homepage"*/ "./messageNotice.vue"));
